import HObject from '@/core/HObject.js'
import * as BABYLON from 'babylonjs'
import ENV from 'ENV'
import { inPerimeter } from '@/core/utils.js'

export default class Avatar extends HObject {
  constructor(startX, startY, startZ, name = 'default') {
    super(name, 'Avatar', true)
    this.position.x = startX
    this.position.y = startY
    this.position.z = startZ
    this.rotation.y = 0
    this.applyCollisions = true
    this.applyGravity = true

    this.target = {}
    this.resetTarget()
    // var id
    this.velocidad = 5
    this.urlBack = `${ENV.server_back}/api/user/avatar/image/`

    this.avatar = 'profiles/anonymous.png'
    this.email = ''
    if (sessionStorage.getItem('token')) {
      let sesion = JSON.parse(sessionStorage.getItem('datos_usuario_autenticado'))
      if (sesion !== null) {
        this.avatar = sesion.imagen_genero
        this.email = sesion.correo_electronico
      }
    }

    this.representacion = BABYLON.MeshBuilder.CreateCylinder('cone', { diameterTop: 1, tessellation: 32 }, window.scene)
    this.representacion.rotation.x = -90 * Math.PI / 4
    this.representacion.scaling.y = 0.1
    this.representacion.position = new BABYLON.Vector3(this.position.x, this.position.y, this.position.z)
    // representacion.ellipsoid = new BABYLON.Vector3(0.5, 1.0, 0.5)

    this.materialAvatar = new BABYLON.StandardMaterial('avatar', window.scene)
    this.materialAvatar.emissiveTexture = new BABYLON.Texture(this.getUrlAvatarImage(this.avatar), window.scene)

    this.representacion.material = this.materialAvatar

    // Base para contacto con piso para colisiones
    this.base = BABYLON.MeshBuilder.CreatePlane('base', { width: 1, height: 1 }, window.scene)
    this.base.rotation.x = 90 * Math.PI / 4
    this.base.position.z = -0.7
    this.base.visibility = false
    this.base.parent = this.representacion
  }

  getUrlAvatarImage (filename) {
    return this.urlBack + filename.replace('profiles/', '')
  }

  // Getters and setters
  getRepresentacion () {
    return this.representacion
  }

  getBase () {
    return this.base
  }

  setRepresentacion (obj) {
    this.representacion = obj
  }

  setImageAvatar (imagen) {
    this.avatar = imagen
    this.materialAvatar = new BABYLON.StandardMaterial('avatar', window.scene)
    this.materialAvatar.emissiveTexture = new BABYLON.Texture(this.getUrlAvatarImage(this.avatar), window.scene)
    this.representacion.material = this.materialAvatar
    // mesh.getChildMeshes()[0].material = materialAvatar
  }

  // Sustituir los siguientes metodos set con updateMeshesPositionRotation cuando se use MeshRoot
  setX (newX) {
    this.x = newX
    this.representacion.position.x = newX
  }

  setY (newY) {
    this.y = newY
    this.representacion.position.y = newY
  }

  setZ (newZ) {
    this.z = newZ
    this.representacion.position.z = newZ
  }

  setRotY (newRotY) {
    this.rotY = newRotY
    this.representacion.rotation.y = newRotY
  }

  update (keys) {
    var prevX = this.position.x
    var prevY = this.position.y
    var prevZ = this.position.z
    var prevRotY = this.rotation.y
    // this.resetTarget()

    if (keys.up) {
      this.resetTarget()
      var forward = new BABYLON.Vector3(parseFloat(Math.sin(parseFloat(this.representacion.rotation.y))) / this.velocidad, 0, parseFloat(Math.cos(parseFloat(this.representacion.rotation.y))) / this.velocidad)
      this.representacion.moveWithCollisions(forward)
    } else if (keys.down) {
      this.resetTarget()
      var backwards = new BABYLON.Vector3(parseFloat(Math.sin(parseFloat(this.representacion.rotation.y))) / this.velocidad, 0, parseFloat(Math.cos(parseFloat(this.representacion.rotation.y))) / this.velocidad)
      backwards = backwards.negate()
      this.representacion.moveWithCollisions(backwards)
    }

    if (keys.left) {
      this.resetTarget()
      this.representacion.rotation.y = this.representacion.rotation.y - 0.02
    }

    if (keys.right) {
      this.resetTarget()
      this.representacion.rotation.y = this.representacion.rotation.y + 0.02
    }

    this.position.x = this.representacion.position.x
    this.position.y = this.representacion.position.y
    this.position.z = this.representacion.position.z
    this.rotation.y = this.representacion.rotation.y

    if (prevX !== this.position.x || prevY !== this.position.y || prevZ !== this.position.z || prevRotY !== this.rotation.y) {
      return true
    }

    return false
  }

  lookAt () {

    if (this.target.x !== null) {
      this.target.ry = - Math.atan2(this.position.z - this.target.z, this.position.x - this.target.x) - (90 * Math.PI / 4)

      if (!inPerimeter(10, this.position.x, this.position.z, this.target.x, this.target.z)) {

        this.representacion.rotation.y = this.target.ry
        this.rotation.y = this.target.ry

        var forward = new BABYLON.Vector3(parseFloat(Math.sin(parseFloat(this.representacion.rotation.y))) / this.velocidad, 0, parseFloat(Math.cos(parseFloat(this.representacion.rotation.y))) / this.velocidad)
        this.representacion.moveWithCollisions(forward)
      } else {
        this.resetTarget()
      }
    }

  }

  resetTarget () {
    this.target.x = null
    this.target.y = null
    this.target.z = null
    this.target.ry = null
  }
}



// WEBPACK FOOTER //
// ./src/core/Avatar.js